<template>
  <div class="sea_wrap bim">
    <!-- header 추가 -->
    <div class="header">
      <div class="header_inner">
        <div class="logo_wrap">
          <h1 class="logo">
            <img src="/img/sea/bim_logo.svg" alt="daewoo" />
          </h1>
          <p class="logo_info">압해화원 도로건설공사 제2공구</p>
        </div>

        <div class="header_info">
          <p class="info_date">{{ dayText }}</p>
          <p />
          <p class="info_week">{{ weekText }}</p>
          <p class="info_time">{{ timeText }}</p>
        </div>
        <div class="header_view_btn">
          <button
            v-show="bimOn"
            type="button"
            class="btn_view"
            @click="changeMap"
          >
            지도 보기
          </button>
          <button
            v-show="mapOn"
            type="button"
            class="btn_view"
            @click="changeBim"
          >
            진척도 보기
          </button>
          <button
            v-show="mapOn"
            type="button"
            class="btn_view btn_analysis"
            @click="goAnalysis"
          >
            운행 분석
          </button>
          <button type="button" class="btn_view btn_manual" @click="openManual">
            매뉴얼
          </button>
          <button
            type="button"
            class="btn_view btn_admin"
            @click="goAdmin"
            title="관리자 대시보드로 이동"
          >
            관리자 대시보드
          </button>
        </div>
        <p class="menu_btn">
          <button
            type="button"
            class="btn_menu1"
            :class="menu === true ? 'on' : ''"
            @click="onClickSetting"
          />
        </p>
      </div>
    </div>

    <!-- dashboard 추가 -->
    <div v-show="!mapFullScreen" class="dashboard_wrap">
      <!-- bridge dashboard -->
      <div class="dashboard">
        <div v-for="(bim, index) in bimTotals" :key="index" class="column_box">
          <div :class="['column', { 'column-selected': bim.bimId === bimId }]">
            <div class="title" @click="onMove(bim.bimId)">{{ bim.name }}</div>
            <div class="progress">
              {{ bim.finishCount }}/{{ bim.totalCount }}
            </div>
            <div class="data_chart">
              <div
                class="chart_percent"
                :style="`width: ${calcPercentage(
                  bim.totalCount,
                  bim.finishCount
                )}%`"
              />
            </div>
            <div class="count">
              진행중
              <div class="num">{{ bim.ingCount }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- information dashboard 재정리 -->
      <div class="box-infomation">
        <div class="box-item item-percent">
          <div class="box-content">
            <div class="content-box box-01">
              <vue-flip v-model="cardFlip" width="100%" height="100%">
                <template v-slot:front>
                  <div class="side side1">
                    <div class="gauge_item_chart chart_01">
                      <svg
                        class="radial-progress"
                        :data-percentage="site.progressRate"
                        viewBox="0 0 80 80"
                      >
                        <!-- data-percentage 에 % 값 변경 하면 됩니다. -->
                        <defs>
                          <linearGradient
                            id="gradient"
                            x1="0%"
                            y1="0%"
                            x2="0%"
                            y2="100%"
                          >
                            <stop offset="0%" stop-color="#56850f" />
                            <stop offset="100%" stop-color="#85c621" />
                          </linearGradient>
                        </defs>
                        <circle class="incomplete" cx="40" cy="40" r="35" />
                        <circle
                          class="complete"
                          stroke="url(#gradient)"
                          cx="40"
                          cy="40"
                          r="35"
                          :style="'stroke-dashoffset: ' + calcProgress(0)"
                        />
                      </svg>
                      <div class="center_text">
                        <p class="number">{{ site.progressRate }}<em>%</em></p>
                        <p class="description">공정률</p>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:back>
                  <div class="side side2">
                    <div class="gauge_item_chart chart_02">
                      <svg
                        class="radial-progress"
                        :data-rercentage="site.progress"
                        viewBox="0 0 80 80"
                      >
                        <!-- data-percentage 에 % 값 변경 하면 됩니다. -->
                        <defs>
                          <linearGradient
                            id="gradient2"
                            x1="0%"
                            y1="0%"
                            x2="0%"
                            y2="100%"
                          >
                            <stop offset="0%" stop-color="#dfaa0b" />
                            <stop offset="100%" stop-color="#f9e222" />
                          </linearGradient>
                        </defs>
                        <circle class="incomplete" cx="40" cy="40" r="35" />
                        <circle
                          class="complete"
                          stroke="url(#gradient2)"
                          cx="40"
                          cy="40"
                          r="35"
                          :style="'stroke-dashoffset: ' + calcProgress(-20)"
                        />
                      </svg>
                      <div class="center_text">
                        <p class="number">{{ site.progressDay }}<em>일</em></p>
                        <p class="description">공사일</p>
                      </div>
                    </div>
                  </div>
                </template>
              </vue-flip>
            </div>
          </div>
        </div>

        <div class="box-item item-weather">
          <div class="box-content">
            <p
              class="title"
              style="color: white; font-size: 15px"
              @click="changeWeather"
            >
              {{ location }}
            </p>
            <div class="content-box box-01">
              <div class="item">
                <vue-flip v-model="cardFlip" width="100%" height="100%">
                  <template v-slot:front>
                    <div class="side side1">
                      <div class="item">
                        <div class="weather_content content_01">
                          <div class="number">
                            {{
                              oceanInfo.waveHeight ? oceanInfo.waveHeight : 0
                            }}
                          </div>
                          <p class="title">평균파고(m)</p>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:back>
                    <div class="side side2">
                      <div class="item">
                        <div class="weather_content content_03">
                          <div class="number">
                            {{ oceanInfo.airTemp ? oceanInfo.airTemp : 0 }}
                          </div>
                          <p class="title">대기온도</p>
                        </div>
                      </div>
                    </div>
                  </template>
                </vue-flip>
              </div>
            </div>
            <div class="content-box box-02">
              <div class="item">
                <vue-flip v-model="cardFlip" width="100%" height="100%">
                  <template v-slot:front>
                    <div class="side side1">
                      <div class="item">
                        <div class="weather_content content_05">
                          <div class="number ch">
                            {{
                              oceanInfo.currentDir ? oceanInfo.currentDir : ""
                            }}
                          </div>
                          <p class="title">파향</p>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:back>
                    <div class="side side2">
                      <div class="item">
                        <div class="weather_content content_04">
                          <div class="number">
                            {{ oceanInfo.windSpeed ? oceanInfo.windSpeed : 0 }}
                          </div>
                          <p class="title">풍속</p>
                        </div>
                      </div>
                    </div>
                  </template>
                </vue-flip>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--- 추가 alert -->
      <!-- <div class="box-infomation alert">
        <div
          v-show="warningTitle.length > 0"
          class="box-item item-alert"
          style="display: block"
        >
          <div class="box-content">
            <div class="content-box box-01">
              <div class="alert-card">
                <p class="cont">{{ warningContent }}</p>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!--- 추가 alert //-->
    </div>
    <!-- dashboard_wrap //-->

    <div :class="['canvas_wrap', { canvas_wrap_fullscreen: mapFullScreen }]">
      <div v-show="!mapFullScreen" id="bim-type-data" class="canvas_info">
        <div
          v-for="(bim, index) in bimTypeProgressResponse"
          :key="index"
          class="info_btns"
        >
          <p class="title">{{ bim.name }}</p>
          <div class="legend">
            <div class="info comp1">{{ bim.totalCount }}</div>
            <div class="info comp2">{{ bim.ingCount }}</div>
            <div class="info comp3">{{ bim.finishCount }}</div>
          </div>
        </div>
      </div>

      <div class="canvas_graph">
        <div v-show="bimOn == true" class="canvas_inner">
          <canvas
            v-if="unityContext"
            ref="unityCanvas"
            id="unity-canvas"
            style="width: 100%; height: 100%"
          />
        </div>
        <div
          v-show="mapOn == true"
          id="map"
          :class="['map_wrap', { map_wrap_fullscreen: mapFullScreen }]"
        />
        <choice-map-style
          v-if="mapOn == true && deviceInfoProp"
          :device-info="deviceInfoProp"
          :route-playing="routePlaying"
          @changeMapStyle="changeMapStyle"
          @moveBookmarks="moveBookmarks"
          @calendarCallBack="calendarCallBack"
          @refreshCallBack="refreshCallBack"
          @changeDate="changeDate"
          @updateRtkPositions="updateRtkPositions"
          @drawRtkRoute="drawRtkRoute"
          @clearRtkRoute="clearRtkRoute"
          @playRoute="playRoute"
          @pauseRoute="pauseRoute"
          @stopRoute="stopRoute"
          @trackEquipment="trackEquipment"
          @stopTracking="stopTracking"
        />
      </div>
    </div>
    <popup-dash-admin ref="popupDashAdmin" />
    <confim-weather ref="confirmWeather" @weatherCallBack="weatherCallBack" />
  </div>
</template>
<script>
import UnityWebgl from "unity-webgl";
import SiteCommonApi from "../api/osm/SiteCommonApi";

import CustomObjectApi from "../api/osm/CustomObjectApi";

import ChoiceMapStyle from "../components/mapObject/ChoiceMapStyle.vue";
import PopupDashAdmin from "../components/popup/PopupDashAdmin.vue";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { Threebox } from "threebox-plugin";
import ConfimWeather from "../components/popup/ConfirmWeather.vue";

import {
  MAPBOX_ACCESS_TOKEN,
  MAPBOX_MAP_STYLE,
  MAPBOX_MAP_STYLE_SATELLITE,
  DEV_LEVEL,
  SITE_ID,
} from "../const";

// Unity 인스턴스는 필요할 때 생성하도록 변경
var Unity = null;

import WeatherApi from "../api/coco/WeatherApi";

import VueFlip from "vue-flip";

import { mapActions } from "vuex";
import EquipmentApi from "../api/osm/EquipmentApi";

import {
  cstrLine,
  officePolygon,
  bridgePanel,
  tunnelPanel,
  setGisInfo,
  generateDriverTypeIconElement,
  generatShipIconElement,
} from "../helper/MapObjectHelper";

export default {
  name: "BimProgressDashBoard",
  components: {
    "vue-flip": VueFlip,
    ChoiceMapStyle,
    PopupDashAdmin,
    ConfimWeather,
  },
  data() {
    // route에서 bimId 가져오기
    const bimId = parseInt(this.$route?.params?.id) || 1;

    return {
      location: "압해",
      menu: false,
      site: { name: "", progress: 0, progressRate: 0 },
      oceanInfo: {},
      cardFlip: false,
      warningTitle: "",
      warningContent: "",
      interval: 3000,
      unityContext: null, // Unity는 BIM 모드에서만 초기화
      bimId: bimId,
      bimTotals: [],
      dayText: "0000.00.00",
      weekText: "?요일",
      timeText: "00:00:00",
      bimTypeProgressResponse: [],
      accessToken: MAPBOX_ACCESS_TOKEN,
      mapStyle: MAPBOX_MAP_STYLE,
      mapStyleSatellite: MAPBOX_MAP_STYLE_SATELLITE,
      map: null,
      mapInitInfo: {},
      intervals: [],
      markerMap: {},
      siteId: localStorage.getItem(SITE_ID),
      devLevel: localStorage.getItem(DEV_LEVEL)
        ? localStorage.getItem(DEV_LEVEL)
        : 0,
      mapOn: false,
      bimOn: true,
      mapFullScreen: false,
      model3dArray: [
        {
          //달리율도교
          objSrc: "/model/2/daliuldo_mini_final.gltf",
          scale: 40,
          rotation: { x: 90, y: 180, z: 0 },

          lng: 126.31593,
          lat: 34.78873,
          altitude: -22,
          id: 1,
        },
        {
          //율도압해
          objSrc: "/model/2/uldoapheaModel_mini_final.gltf",
          scale: 1,
          rotation: { x: 90, y: -2, z: 0 },
          lng: 126.3307,
          lat: 34.8169,
          altitude: -36,
          id: 2,
        },
      ],
      data: null,
      error: null,
      eventSource: null,
      deviceHistory: {},
      devicePin: {},
      deviceList: [], //TODO 관리
      deviceInfo: {},
      deviceReviewId: null,
      deviceInfoProp: null,
      rtkMarkers: [],
      rtkRouteLayerId: "rtk-route-layer",
      rtkRouteSourceId: "rtk-route-source",
      rtkRouteMarkers: [],
      // 경로 재생 관련
      routePlaying: false,
      routeAnimationId: null,
      routePlaybackMarker: null,
      routeCoordinates: [],
      routeCurrentIndex: 0,
      routePlaybackSpeed: 50, // ms per point
      // 경로 찾기 전 원래 지도 위치 저장
      savedMapView: null,
      // 장비 추적 관련
      trackingDeviceId: null,
      trackingZoomLevel: 15, // 주변 지역이 보이도록 낮춤
      // 경로 재생 정보 표시
      routeData: [],
      routeInfoPopup: null,
    };
  },
  computed: {
    currentViewMode() {
      return this.$route?.meta?.viewMode === "map" ? "map" : "bim";
    },
  },
  watch: {
    $route(to) {
      if (to?.params?.id) {
        this.bimId = parseInt(to.params.id) || this.bimId;
      }
      this.applyViewMode(this.currentViewMode);
    },
  },
  created() {
    console.log("created - Unity:", Unity);
    console.log("created - this.unityContext:", this.unityContext);
    this.getTime();
    console.log(this.bimId);
    // created에서는 뷰 모드 상태만 설정 (Unity 초기화는 mounted에서)
    const view = this.currentViewMode === "map" ? "map" : "bim";
    this.mapFullScreen = view === "map";
    this.mapOn = view === "map";
    this.bimOn = view !== "map";

    // 지도 모드일 때 Unity 전역 객체 및 이벤트 핸들러 정리
    if (view === "map") {
      this.cleanupUnityGlobals();
    }
  },
  mounted() {
    // Unity는 BIM 모드일 때만 초기화 (applyViewMode에서 처리)
    // this.setupEventSource();
    for (var i = 0; i < 100; i++) {
      clearInterval(i);
    }

    setInterval(this.getTime, 1000);

    setInterval(this.getOceanInfo, 1000 * 60 * 60);
    setInterval(this.getSpecialReport, 1000 * 60 * 20);

    setTimeout(() => {
      location.reload();
    }, 600000 * 6 * 24); // 600000밀리초 = 10분

    SiteCommonApi.detail().then((res) => {
      this.site = res;
      this.mapInitInfo = JSON.parse(this.site.mapInitInfo);
      this.mapinit(this.mapStyleSatellite);
    });

    // BIM 모드일 때만 Unity 초기화
    if (this.currentViewMode !== "map") {
      this.initUnity();
      this.onBimProgress();
    }

    this.onBimTypeProgress();
    this.getInit();

    this.setupEventSource();
  },
  beforeDestroy() {
    // Unity 인스턴스 정리
    this.destroyUnity();
    if (this.eventSource) {
      this.eventSource.close(); // Clean up the EventSource connection when the component is destroyed
    }
  },
  methods: {
    ...mapActions(["setMapBounds"]),
    initUnity() {
      // 이미 Unity가 있으면 먼저 정리
      this.destroyUnity();

      // Unity 전역 객체 정리
      if (window.__UnityLib__) {
        delete window.__UnityLib__;
      }

      const buildUrl = "/bim/" + this.bimId;
      Unity = new UnityWebgl({
        loaderUrl: buildUrl + "/osmBimProgress.loader.js",
        dataUrl: buildUrl + "/osmBimProgress.data",
        frameworkUrl: buildUrl + "/osmBimProgress.framework.js",
        codeUrl: buildUrl + "/osmBimProgress.wasm",
      });

      this.unityContext = Unity;

      // canvas에 마운트
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.unityContext && this.$refs.unityCanvas) {
            console.log("Mounting Unity to canvas...");
            this.unityContext.create(this.$refs.unityCanvas);
          }
        }, 100);
      });
    },
    applyViewMode(mode) {
      const view = mode === "map" ? "map" : "bim";
      this.mapFullScreen = view === "map";
      this.mapOn = view === "map";
      this.bimOn = view !== "map";

      if (view === "map") {
        // 지도 모드: Unity 정리
        this.destroyUnity();
        this.$nextTick(() => {
          if (this.map) this.map.resize();
        });
      } else {
        // BIM 모드: Unity 초기화 (아직 없는 경우에만)
        if (!this.unityContext) {
          this.$nextTick(() => {
            this.initUnity();
            this.onBimProgress();
          });
        }
      }
    },
    async setupEventSource(param) {
      this.deviceList = [];
      this.deviceInfo = {};
      this.deviceHistory = {};
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");

      const formattedToday = `${year}-${month}-${day}`;

      let formattedDate = `${year}-${month}-${day}`;
      const result = await EquipmentApi.equipList();

      this.deviceList = result.content;
      if (param) {
        // this.deviceList.push(param);
        formattedDate = param;
      } else {
        // const result = await EquipmentApi.equipList();
        // this.deviceList = result.content;
        // const today = new Date();
        // const year = today.getFullYear();
        // const month = String(today.getMonth() + 1).padStart(2, "0");
        // const day = String(today.getDate()).padStart(2, "0");
        // formattedDate = `${year}-${month}-${day}`;
      }

      const promises = this.deviceList.map(async (device) => {
        const id = device.id;
        const historyList = await CustomObjectApi.historyDate(
          id,
          formattedDate,
          formattedDate
        );

        this.deviceHistory[id] = historyList;

        this.deviceInfo[id] = {
          distance: this.calculateTotalDistance(historyList),
          totalTime: this.calculateTotalTime(historyList),
        };
      });
      await Promise.all(promises);

      this.deviceInfoProp = this.deviceInfo;
      // this.$set(this, "deviceInfoProp", { ...this.deviceInfo });
      if (param === undefined || param === formattedToday) {
        const idList = this.deviceList.map((item) => item.id);
        console.log("idList", idList);
        const queryString = idList
          .map((param) => `idList=${encodeURIComponent(param)}`)
          .join("&");
        // const baseUrl = "http://localhost:20000/api/v1/map/object/sse";
        const baseUrl = "https://progress.dscosm.com/osm/api/v1/map/object/sse";
        const urlWithParams = `${baseUrl}?${queryString}`;
        this.eventSource = new EventSource(urlWithParams);
        this.eventSource.onmessage = (event) => {
          console.log("New message from server: ", event.data);
          this.data = JSON.parse(event.data); // Update the UI with the new data
          if (this.data.length > 0) {
            this.data.forEach((item) => {
              this.updateDeviceCount(item.memberId, item.count);
              if (item.lng && item.lat) {
                this.updateDevicePin(item.memberId, [item.lng, item.lat]);
              }
            });
          }
        };
        this.eventSource.onerror = (error) => {
          console.error("Error occurred:", error);
          this.error = "Connection error. Please try again.";
          this.eventSource.close();
        };
      }
    },
    async onBimProgress() {
      this.bimProgressResponse = await SiteCommonApi.getBimProgress(this.bimId);
      console.log(this.bimProgressResponse);

      // Unity가 초기화되지 않은 경우 리턴
      if (!this.unityContext) return;

      this.unityContext.on("mounted", () => {
        setTimeout(() => {
          if (!this.bimProgressResponse || !this.bimProgressResponse.partList)
            return;
          this.bimProgressResponse.partList.forEach((item, index) => {
            setTimeout(() => {
              console.log("sending ");
              if (Unity) {
                Unity.send("GameObject", "Sendnum", item.partName);
                Unity.send("GameObject", "sendType", "" + item.status);
              }
              // 여기에 각 요소에 대해 수행하고 싶은 작업을 추가할 수 있습니다.
            }, index * 100);
          });
        }, this.interval);
      });
    },
    async onBimTypeProgress() {
      this.bimTypeProgressResponse = await SiteCommonApi.getBimType(this.bimId);
    },
    onMove(bimId) {
      const targetView = this.currentViewMode === "map" ? "map" : "bim";
      const path =
        targetView === "map"
          ? `/dashboard/${bimId}/map`
          : `/dashboard/${bimId}`;
      this.$router.push({ path });
    },
    async getInit() {
      this.bimTotals = await SiteCommonApi.getBimProgressCounts();
      this.site = await SiteCommonApi.detail();
      this.getOceanInfo();
      this.getSpecialReport();
    },
    async getSpecialReport() {
      this.reportResult = await WeatherApi.specialReport();

      this.warningTitle = "";
      this.warningContent = "";

      this.warningTitle = this.reportResult
        .map((report) => report.warnVar + report.warnStress)
        .join();

      //this.warningTitle = this.warningTitle || "주의사항";
      this.warningContent = this.reportResult
        .map(
          (report) =>
            `${report.areaName}  ${report.time.substr(
              0,
              2
            )}:${report.time.substr(2, 2)}경 ${report.warnVar}  ${
              report.warnStress
            }  ${report.command}`
        )
        .join();
      //this.warningContent = this.warningContent || "현재 없음";
    },
    async getOceanInfo() {
      this.oceanInfo = await WeatherApi.oceanInfo();
    },
    calcProgress(add) {
      return 220 - this.site.progressRate * 2.2 + add;
    },
    calcPercentage(totalCount, finishCount) {
      if (totalCount === 0 || !totalCount) return 0;
      return Math.round(finishCount / totalCount);
    },
    getTime() {
      const date = new Date();
      const week = new Array(
        "일요일",
        "월요일",
        "화요일",
        "수요일",
        "목요일",
        "금요일",
        "토요일"
      );

      this.weekText = week[date.getDay()];
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();

      this.dayText = `${year}.${month < 10 ? `0${month}` : month}.${
        day < 10 ? `0${day}` : day
      }`;

      this.timeText = `${hours < 10 ? `0${hours}` : hours}:
            ${minutes < 10 ? `0${minutes}` : minutes}:
            ${seconds < 10 ? `0${seconds}` : seconds}`;
    },
    changeMap() {
      // Unity WebGL 문제로 인해 강제 새로고침
      window.location.hash = `/dashboard/${this.bimId}/map`;
      window.location.reload();
    },
    changeBim() {
      // Unity WebGL 문제로 인해 강제 새로고침
      window.location.hash = `/dashboard/${this.bimId}`;
      window.location.reload();
    },
    goAnalysis() {
      // Unity WebGL 문제로 인해 강제 새로고침
      window.location.hash = `/dashboard/${this.bimId}/analysis`;
      window.location.reload();
    },
    goAdmin() {
      window.location.hash = `/bim/${this.bimId}`;
      window.location.reload();
    },
    destroyUnity() {
      if (this.unityContext) {
        try {
          // Unity 이벤트 리스너 제거
          this.unityContext.off("mounted");
          // Unity 인스턴스 destroy
          this.unityContext.destroy();
        } catch (e) {
          console.warn("Unity destroy error:", e);
        }
        this.unityContext = null;
        Unity = null;
      }
      // Unity 전역 객체 정리
      if (window.__UnityLib__) {
        delete window.__UnityLib__;
      }
      // Unity canvas 관련 전역 이벤트 리스너 정리
      if (window.unityInstance) {
        window.unityInstance = null;
      }
      // Unity가 등록한 마우스 이벤트 핸들러 정리를 위해 canvas 제거
      const canvas = document.getElementById("unity-canvas");
      if (canvas) {
        // canvas의 모든 이벤트 리스너를 제거하기 위해 복제 후 교체
        const parent = canvas.parentNode;
        if (parent) {
          canvas.remove();
        }
      }
    },
    changeMapStyle(type) {
      // Clean up RTK markers and routes first
      if (this.rtkMarkers) {
        this.rtkMarkers.forEach((marker) => marker.remove());
        this.rtkMarkers = [];
      }
      this.clearRtkRoute(false);

      // Dispose of Threebox instance first
      if (window.tb) {
        try {
          window.tb.dispose();
        } catch (e) {
          console.warn("Threebox dispose error:", e);
        }
        window.tb = null;
      }

      // Remove existing map if it exists
      if (this.map) {
        try {
          this.map.remove();
        } catch (e) {
          console.warn("Map remove error:", e);
        }
        this.map = null;
      }

      this.markerMap = {};

      if (type === "default") {
        this.mapinit();
      } else {
        this.mapinit(this.mapStyleSatellite);
      }

      // this.contentsBtnsValue.worker = "on";
      // this.contentsBtnsValue.coco = "on";
      // this.contentsBtnsValue.equip = "on";
      // this.contentsBtnsValue.cctv = "on";
    },
    dashboardInterval() {
      if (this.devLevel < 2) {
        this.intervals.push(
          setInterval(() => {
            this.getDashboard();
          }, 1000 * 30)
        );
      }
    },
    async moveBookmarks(item) {
      if (!item) {
        this.map.setCenter(this.mapInitInfo.center);
        this.map.setZoom(this.mapInitInfo.zoom);
        return false;
      }

      if (item.zoomLevel) this.map.setZoom(item.zoomLevel);
      this.map.setCenter([item.lng, item.lat]);
      this.map.setPitch(item.pitch);
      this.map.setBearing(item.bearing);
      this.$toast.success(`${item.name}로 이동 했습니다`);
    },
    async makePanel() {
      const bridgeList = [];
      const tunnelList = [];

      const panelList = await CustomObjectApi.mapPenel();

      panelList.map((item) => {
        item.lnglat = [item.lng, item.lat];
        if (item.panelType === "BRIDGE") {
          bridgeList.push(item);
          return false;
        }
        if (item.panelType === "TUNNEL") {
          tunnelList.push(item);
          return false;
        }
      });

      bridgeList.map((res) => {
        bridgePanel(res, this.map, mapboxgl);
      });

      tunnelList.map((res) => {
        tunnelPanel(res, this.map, mapboxgl);
      });

      const lineList = await CustomObjectApi.mapLine();
      officePolygon(this.site, this.map, mapboxgl);
      cstrLine(lineList, this.site, this.map, mapboxgl);
    },
    model3d() {
      this.map.addLayer({
        id: "custom_layer",
        type: "custom",
        renderingMode: "3d",
        onAdd: async () => {
          this.model3dArray.map((item) => {
            window.tb.loadObj(
              {
                type: "gltf",
                obj: item.objSrc,
                units: "meters",
                scale: item.scale,
                // rotation: JSON.parse(item.rotation),
                rotation: item.rotation,
                anchor: "center",
              },
              (model) => {
                model.setCoords([item.lng, item.lat]);
                model.userData = { id: item.id }; // 모델에 고유 ID 추가
                window.tb.add(model);
              }
            );
          });
        },
        render: () => window.tb.update(),
      });
      this.map.on("click", (e) => {
        // 클릭된 위치에서 3D 객체 검색
        const features = window.tb.queryRenderedFeatures(e.point, {
          layers: ["custom_layer"],
        });

        if (features.length > 0) {
          const clickedFeature = features[0];
          console.log(clickedFeature);

          // 클릭된 객체의 userData를 가져옵니다
          if (clickedFeature && clickedFeature.object) {
            let modelId = null;

            // `userData`가 직접 설정되지 않은 경우 상위 객체를 확인
            if (clickedFeature.object.userData.id) {
              modelId = clickedFeature.object.userData.id;
            } else {
              // 상위 객체 탐색
              let parent = clickedFeature.object.parent;
              while (parent) {
                if (parent.userData && parent.userData.id) {
                  modelId = parent.userData.id;
                  break;
                }
                parent = parent.parent;
              }
            }

            if (modelId) {
              console.log("클릭된 모델 ID:", modelId);
              let url = "";
              if (modelId === 1) {
                url = this.$router.resolve({ path: `/A` }).href;
              } else if (modelId === 2) {
                url = this.$router.resolve({ path: `/B` }).href;
              }
              window.open(url, "_blank");
              // 필요한 작업 수행
            } else {
              console.log("클릭된 객체에 userData가 없습니다.");
            }
          } else {
            console.log("클릭된 객체에 userData가 없습니다.");
          }
        } else {
          console.log("클릭된 위치에 3D 객체가 없습니다.");
        }
      });
    },
    async getDashboard() {
      const points = await CustomObjectApi.dashboard();
      if (points) {
        points.forEach((value) => {
          const el = generateDriverTypeIconElement(
            value,
            this.workerList,
            this.carList,
            this.companyList
          );

          if (el) {
            const key = `${value.driverType !== null ? "EQUIP" : "WORKER"}-${
              value.id.memberId
            }`;
            if (this.markerMap[key]) {
              this.markerMap[key].removeLabel();
            }

            if (
              key.includes("WORKER") &&
              this.contentsBtnsValue.worker !== "on"
            ) {
              return;
            }

            if (
              key.includes("EQUIP") &&
              this.contentsBtnsValue.equip !== "on"
            ) {
              return;
            }

            this.markerMap[key] = this.addLabel([value.lng, value.lat], el);
          }
        });
      }
      // if (this.siteId === "2") {
      //   new mapboxgl.Marker(generate3dIconElement("a"))
      //     .setLngLat([126.31392640151309, 34.79012200212962])
      //     .setPitchAlignment("map")
      //     .addTo(this.map);

      //   new mapboxgl.Marker(generate3dIconElement("b"))
      //     .setLngLat([126.32863645685262, 34.8188612343355])
      //     .setPitchAlignment("map")
      //     .addTo(this.map);

      //   new mapboxgl.Marker(generate3dIconElement("c"))
      //     .setLngLat([126.35667529906976, 34.814411994044875])
      //     .setPitchAlignment("map")
      //     .addTo(this.map);
      // }
    },
    getDashboardWork() {
      if (this.workList && window.tb) {
        this.workList.forEach((value) => {
          const key = `COCO-${value.id}`;
          const el = document.createElement("p");
          const imgEl = document.createElement("img");
          el.className = "marker marker type_coco";
          imgEl.className = "coco";
          imgEl.dataset.id = value.id;
          // el.dataset.id = value.id;

          imgEl.style = "top:12rem;right:19.4rem";
          imgEl.src = "../img/common/map/pin_coco.svg";
          el.append(imgEl);
          el.addEventListener("click", () => {
            this.openWorkView(
              this.workList.find((work) => work.id === value.id)
            );
          });

          if (this.markerMap[key]) {
            this.markerMap[key].removeLabel();
          }
          if (this.contentsBtnsValue.coco === "on")
            this.markerMap[key] = this.addLabel(
              [value.longitude, value.latitude],
              el
            );
        });
      }
    },
    addClickEvent() {
      this.map.on("click", (e) => {
        // Query features at the click point

        if (!this.map.getLayer("rectangles-layer")) return;

        const features = this.map.queryRenderedFeatures(e.point, {
          layers: ["rectangles-layer"],
        });

        if (features.length > 0) {
          const clickedFeature = features[0];
          const rectangleId = clickedFeature.properties.id;
          const rectangleTitle = clickedFeature.properties.title;

          console.log(`Clicked Rectangle ID: ${rectangleId}`);
          console.log(`Clicked Rectangle Title: ${rectangleTitle}`);
          if (rectangleId === 1) {
            const url = this.$router.resolve({ path: `/A` }).href;

            window.open(url, "_blank");
          } else if (rectangleId === 2) {
            const url = this.$router.resolve({ path: `/B` }).href;

            window.open(url, "_blank");
          }
        }
      });
    },
    addRectangles() {
      // Define coordinates for two rectangles
      const coordinates = [
        // Rectangle 1
        [
          [126.31771095028051, 34.78453091268581],
          [126.31587457844086, 34.78421386974844],
          [126.31467429078828, 34.793161532868325],
          [126.31580715838015, 34.79313163545861],
          [126.31771095028051, 34.78453091268581],
        ],
        // Rectangle 2
        [
          [126.32773855830084, 34.81454805062508],
          [126.32718053755423, 34.815035161527476],
          [126.33325338966932, 34.819510764725635],
          [126.33410818780987, 34.81867595930483],
          [126.32773855830084, 34.81454805062508],
        ],
      ];

      // Add a source for the rectangles
      this.map.addSource("rectangles", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: coordinates.map((coords, index) => ({
            type: "Feature",
            geometry: {
              type: "Polygon",
              coordinates: [coords],
            },
            properties: {
              id: index + 1, // Unique ID for each rectangle
              title: `Rectangle ${index + 1}`,
            },
          })),
        },
      });

      // Add a layer for the rectangles
      this.map.addLayer({
        id: "rectangles-layer",
        type: "fill",
        source: "rectangles",
        layout: {},
        paint: {
          "fill-color": "#888888", // Fill color
          "fill-opacity": 0, // Fill opacity
        },
      });

      // Optionally, add borders around the rectangles
      this.map.addLayer({
        id: "rectangles-border",
        type: "line",
        source: "rectangles",
        layout: {},
        paint: {
          "line-color": "#000000", // Border color
          "line-width": 1, // Border width
          "line-opacity": 0, // Line opacity
        },
      });

      // this.map.setLayoutProperty("rectangles-border", "visibility", "none");
      // this.map.setLayoutProperty("rectangles-layer", "visibility", "none");
    },
    createDevicePin() {
      console.log("this.deviceList", this.deviceList);
      this.deviceList.forEach((device) => {
        const id = device.id;
        console.log("device.id", device.id);
        console.log("this.devicePin[id]", this.devicePin[id]);
        if (this.devicePin[id]) {
          console.log("기존핀 제거");
          this.devicePin[id].remove(); // 기존 핀을 지도에서 제거
          if (this.map.getSource(`linesDev-${id}`)) {
            // 이미 소스가 있으면 삭제

            // this.map.removeLayer("rectangles-layer");
            this.map.removeLayer(`linesDev-${id}`);

            this.map.removeSource(`linesDev-${id}`);
          }
        }
        if (this.deviceHistory[id] && this.deviceHistory[id].length < 2) return;
        // if (this.devicePin[id]) {
        //   console.log("기존핀 제거");
        //   this.devicePin[id].remove(); // 기존 핀을 지도에서 제거
        // }
        this.devicePin[id] = new mapboxgl.Marker(generatShipIconElement(id))
          .setLngLat(this.deviceHistory[id][this.deviceHistory[id].length - 1])
          .setPitchAlignment("map")
          .addTo(this.map);

        console.log("this.devicePin[id]", this.devicePin[id]);
        const pinElement = this.devicePin[id]._element;
        const nameEl = pinElement.querySelector("span");
        if (nameEl) {
          nameEl.innerText = device.name;
        }

        const lineFeatures = [
          {
            type: "Feature",
            properties: {
              color: "#0b00bf",
            },
            geometry: {
              type: "LineString",
              coordinates: this.deviceHistory[id],
            },
          },
        ];

        if (this.map.getSource(`linesDev-${id}`)) {
          // 이미 소스가 있으면 삭제

          // this.map.removeLayer("rectangles-layer");
          this.map.removeLayer(`linesDev-${id}`);

          this.map.removeSource(`linesDev-${id}`);
        }
        this.map.addSource(`linesDev-${id}`, {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: lineFeatures,
          },
        });
        this.map.addLayer({
          id: `linesDev-${id}`,
          type: "line",
          source: `linesDev-${id}`,
          paint: {
            "line-width": 2,
            "line-color": ["get", "color"],
          },
        });
      });
    },
    updateDevicePin(deviceId, lngLat) {
      console.log("1##################");
      console.log(this.deviceHistory);
      console.log(deviceId);
      console.log("1##################");
      if (!this.deviceHistory[deviceId]) return;
      const lastPoint =
        this.deviceHistory[deviceId][this.deviceHistory[deviceId].length - 1];

      if (lastPoint[0] === lngLat[0] && lastPoint[1] === lngLat[1]) return;
      console.log("##################");
      console.log(lastPoint);
      console.log(lngLat);

      console.log("##################");
      this.deviceHistory[deviceId].push(lngLat);

      const lastPoint2 = this.deviceHistory[deviceId].slice(-2);

      this.updateDeviceDistance(deviceId, lastPoint2);
      this.drawLine(deviceId, lastPoint2);

      if (this.deviceReviewId === null || this.deviceReviewId === deviceId) {
        //다시보기중엔 update X
        this.devicePin[deviceId].setLngLat(lngLat);
      }
    },
    updateDeviceDistance(deviceId, lastPoint2Point) {
      const distance = this.calculateTotalDistance(lastPoint2Point);
      var orgDistance = 0;

      if (this.deviceInfo[deviceId]) {
        orgDistance = this.deviceInfo[deviceId]["distance"];
      }
      this.deviceInfo[deviceId] = {
        distance: orgDistance + distance,
      };
    },
    updateDeviceCount(deviceId, count) {
      this.deviceInfo[deviceId] = {
        count: count,
      };
    },
    drawLine(deviceId, lineList) {
      const routeSource = this.map.getSource(`linesDev-${deviceId}`);
      const currentData = routeSource._data;

      currentData.features.push({
        type: "Feature",
        properties: {
          color: "#0b00bf",
        },
        geometry: {
          type: "LineString",
          coordinates: lineList,
        },
      });

      routeSource.setData(currentData);
    },
    mapinit(style) {
      // Dispose of Threebox instance first
      if (window.tb) {
        try {
          window.tb.dispose();
        } catch (e) {
          console.warn("Threebox dispose error:", e);
        }
        window.tb = null;
      }

      if (this.map) {
        console.log("Removing existing map...");
        try {
          this.map.remove(); // 기존 map 객체를 제거
        } catch (e) {
          console.warn("Map remove error:", e);
        }
        this.map = null; // this.map을 null로 초기화
      }
      console.log("mapinit");
      if (!style) {
        style = this.mapStyle;
      }
      mapboxgl.accessToken = this.accessToken;
      console.log(this.mapInitInfo);
      this.map = new mapboxgl.Map({
        container: "map", // container ID
        style: style, // style URL
        center: this.mapInitInfo.center,
        // center: [126.74233538655949, 34.71839126770078],
        // zoom: 13.5,
        zoom: this.mapInitInfo.zoom,
        pitch: this.mapInitInfo.pitch,
        bearing: this.mapInitInfo.bearing,
      });

      console.log(this.map);

      // Add zoom controls (+/- buttons and compass)
      this.map.addControl(
        new mapboxgl.NavigationControl({
          showCompass: true,
          showZoom: true,
        }),
        "top-left"
      );

      this.map.on("load", () => {
        this.addClickEvent();
        this.addRectangles();
        this.createDevicePin();
        this.dashboardInterval();

        this.setMapBounds(this.map.getBounds());

        this.makePanel();

        if (this.devLevel < 1)
          CustomObjectApi.mapGisinfo().then((res) => setGisInfo(this.map, res));
      });
      this.map.on("style.load", () => {
        window.tb = new Threebox(
          this.map,
          this.map.getCanvas().getContext("webgl"),
          {
            defaultLights: true,
          }
        );
        this.model3d();
        this.getDashboardWork();
        this.getDashboard();
      });

      this.map.on("moveend", () => {
        this.setMapBounds(this.map.getBounds());
      });

      this.map.on("click", (e) => {
        console.log(`A click event has occurred at ${e.lngLat}`);

        if (!(e.originalEvent.target instanceof HTMLElement)) return;

        if (e.originalEvent.target.className.includes("coco")) {
          this.openWorkView(
            this.workList.find(
              (work) => work.id === Number(e.originalEvent.target.dataset.id)
            )
          );
        } else if (e.originalEvent.target.className.includes("pin-img")) {
          const deviceId = e.originalEvent.target.getAttribute("data-id");
          if (deviceId)
            this.map.setLayoutProperty(
              `linesDev-${deviceId}`,
              "visibility",
              "none"
            );

          this.deviceReviewId = deviceId;

          this.map.addSource("line-source-tmp", {
            type: "geojson",
            data: {
              type: "Feature",
              geometry: {
                type: "LineString",
                coordinates: [],
              },
            },
          });

          this.map.addLayer({
            id: "line-layer-tmp",
            type: "line",
            source: "line-source-tmp",
            layout: {
              "line-join": "round",
              "line-cap": "round",
            },
            paint: {
              "line-color": "#ff0000",
              "line-width": 3,
            },
          });
          this.drawLineWithDelay(deviceId, 0);
        }
      });

      if (this.devLevel > 2) {
        const draw = new MapboxDraw({
          displayControlsDefault: false,
          controls: {
            polygon: true,
            trash: true,
          },
          defaultMode: "draw_polygon",
        });
        this.map.addControl(draw);

        this.map.on("draw.create", this.updateArea);
        this.map.on("draw.delete", this.updateArea);
        this.map.on("draw.update", this.updateArea);
      }
    },
    drawLineWithDelay(deviceId, index) {
      if (index < this.deviceHistory[deviceId].length) {
        const currentCoords = this.deviceHistory[deviceId].slice(0, index + 1);

        this.devicePin[deviceId].setLngLat(
          currentCoords[currentCoords.length - 1]
        );
        // 지도에 새로운 라인 데이터 설정
        this.map.getSource("line-source-tmp").setData({
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: currentCoords,
          },
        });

        // 다음 좌표를 500ms 뒤에 그리기
        setTimeout(() => {
          this.drawLineWithDelay(deviceId, index + 1); // 다음 인덱스로 재귀 호출
        }, 200);
      } else {
        // 모든 좌표를 그린 후 완료 이벤트 처리
        this.onLineDrawingComplete(deviceId);
      }
    },
    onLineDrawingComplete(deviceId) {
      console.log("Line drawing complete!");
      if (this.map.getLayer("line-layer-tmp")) {
        this.map.removeLayer("line-layer-tmp"); // 레이어 삭제
      }

      if (this.map.getSource("line-source-tmp")) {
        this.map.removeSource("line-source-tmp"); // 소스 삭제
      }

      console.log("Line and source removed");
      this.deviceReviewId = null;
      this.map.setLayoutProperty(
        `linesDev-${deviceId}`,
        "visibility",
        "visible"
      );
    },
    updateArea(e) {
      console.log(e);
    },
    async changeDate(param) {
      console.log(param);
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");

      const formattedDate = `${year}-${month}-${day}`;
      console.log(formattedDate);

      if (param !== formattedDate) {
        if (this.eventSource) {
          this.eventSource.close();
        }
      }
      await this.setupEventSource(param);
      this.createDevicePin();
    },
    async calendarCallBack(param) {
      // this.mapinit(this.mapStyleSatellite);

      if (this.eventSource) {
        this.eventSource.close();
      }
      await this.setupEventSource(param);
      this.createDevicePin();

      console.log("calendarCallBack", param);
    },
    async refreshCallBack() {
      this.mapinit(this.mapStyleSatellite);
      await this.setupEventSource();
    },
    updateRtkPositions(positions) {
      if (!this.map) return; // Map doesn't exist yet

      // 기존 RTK 마커 제거
      if (this.rtkMarkers) {
        this.rtkMarkers.forEach((marker) => marker.remove());
      }
      this.rtkMarkers = [];

      // 새 마커 생성
      positions.forEach((pos) => {
        if (pos.latitude && pos.longitude) {
          const speed =
            pos.speed !== null && pos.speed !== undefined
              ? `${Number(pos.speed).toFixed(1)}km/h`
              : "-";
          const name = pos.equipmentName || pos.serialNumber || "장비";
          const angle =
            pos.angle !== null && pos.angle !== undefined ? pos.angle : 0;

          // 접속 상태 판단 로직
          const connTime = pos.lastConnectionDatetime
            ? new Date(pos.lastConnectionDatetime)
            : null;
          const disconnTime = pos.lastDisconnectionDatetime
            ? new Date(pos.lastDisconnectionDatetime)
            : null;
          const isOn = !disconnTime || (connTime && connTime > disconnTime);

          const formatTime = (dateStr) => {
            if (!dateStr) return "-";
            const date = new Date(dateStr);
            return date.toLocaleTimeString("ko-KR", {
              hour12: false,
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            });
          };

          const formatDate = (dateStr) => {
            if (!dateStr) return "--";
            const date = new Date(dateStr);
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${month}-${day}`;
          };

          const formatDateTimeLabel = (dateStr) => {
            if (!dateStr) return "-";
            return `${formatDate(dateStr)} ${formatTime(dateStr)}`;
          };

          const connTimeStr = formatDateTimeLabel(pos.lastConnectionDatetime);
          const disconnTimeStr = formatDateTimeLabel(
            pos.lastDisconnectionDatetime
          );
          const statusColor = isOn ? "#4CAF50" : "#F44336";
          const statusLabel = isOn ? "ON" : "OFF";

          const el = document.createElement("div");
          el.className = "rtk-marker";
          el.dataset.deviceId = pos.deviceId; // Add device ID for tracking
          el.style.cssText =
            "display: flex; flex-direction: column; align-items: center; cursor: pointer;";
          el.innerHTML = `
            <div style="
              background: ${
                isOn
                  ? "linear-gradient(135deg, #4CAF50, #2E7D32)"
                  : "linear-gradient(135deg, #9e9e9e, #616161)"
              };
              border: 2px solid #fff;
              border-radius: 50%;
              width: 20px;
              height: 20px;
              box-shadow: 0 3px 8px rgba(0,0,0,0.35);
              display: flex;
              align-items: center;
              justify-content: center;
              transform: rotate(${angle}deg);
            ">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="white">
                <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"/>
              </svg>
            </div>
            <div style="
              background: rgba(26, 31, 46, 0.92);
              color: #fff;
              padding: 4px 8px;
              border-radius: 6px;
              font-size: 11px;
              white-space: nowrap;
              margin-top: 6px;
              box-shadow: 0 2px 8px rgba(0,0,0,0.3);
              border: 1px solid rgba(255,255,255,0.1);
            ">
              <div style="font-weight: 600; margin-bottom: 2px;">${name}</div>
              <div style="color: #8b95a8; font-size: 10px; display: flex; justify-content: space-between; gap: 8px;">
                <span>속도: ${speed}</span>
                <span style="color: ${statusColor}; font-weight: 700;">${statusLabel}</span>
              </div>
              <div style="color: #8b95a8; font-size: 9px; margin-top: 2px; border-top: 1px solid rgba(255,255,255,0.05); padding-top: 2px;">
                <div>접속: ${connTimeStr}</div>
                <div>해제: ${disconnTimeStr}</div>
              </div>
            </div>
          `;

          const marker = new mapboxgl.Marker({ element: el, anchor: "center" })
            .setLngLat([pos.longitude, pos.latitude])
            .addTo(this.map);

          this.rtkMarkers.push(marker);
        }
      });

      // Auto-track if tracking is active
      if (this.trackingDeviceId) {
        const trackedPosition = positions.find(
          (pos) => pos.deviceId === this.trackingDeviceId
        );

        if (
          trackedPosition &&
          trackedPosition.latitude &&
          trackedPosition.longitude
        ) {
          this.map.flyTo({
            center: [trackedPosition.longitude, trackedPosition.latitude],
            zoom: this.trackingZoomLevel,
            duration: 1200, // 자연스러운 이동
            essential: true, // prefers-reduced-motion 무시하고 애니메이션 실행
            easing: (t) => t * (2 - t), // easeOutQuad - 부드러운 감속
          });
        }
      }
    },
    drawRtkRoute(data) {
      if (!this.map) return; // Map doesn't exist yet

      // 경로 찾기 전 현재 지도 위치 저장 (처음 경로 찾기일 때만)
      if (!this.savedMapView) {
        this.savedMapView = {
          center: this.map.getCenter(),
          zoom: this.map.getZoom(),
          pitch: this.map.getPitch(),
          bearing: this.map.getBearing(),
        };
      }

      // 기존 경로 제거 (위치 복원 없이)
      this.clearRtkRoute(false);

      const { route, equipmentName } = data;
      if (!route || route.length === 0) return;

      // 좌표 배열 생성 [lng, lat]
      const coordinates = route
        .filter((point) => point.longitude && point.latitude)
        .map((point) => [point.longitude, point.latitude]);

      if (coordinates.length < 2) return;

      // 전체 루트 데이터 저장 (최신 -> 과거 순으로 역순)
      const routePoints = route.filter(
        (point) => point.longitude && point.latitude
      );
      this.routeData = [...routePoints].reverse();

      // 좌표만 추출 (역순)
      this.routeCoordinates = this.routeData.map((point) => [
        point.longitude,
        point.latitude,
      ]);
      this.routeCurrentIndex = 0;

      // 경로 소스 추가
      this.map.addSource(this.rtkRouteSourceId, {
        type: "geojson",
        data: {
          type: "Feature",
          properties: { name: equipmentName },
          geometry: {
            type: "LineString",
            coordinates: coordinates,
          },
        },
      });

      // 경로 레이어 추가 (외곽선)
      this.map.addLayer({
        id: this.rtkRouteLayerId + "-outline",
        type: "line",
        source: this.rtkRouteSourceId,
        layout: {
          "line-join": "round",
          "line-cap": "round",
        },
        paint: {
          "line-color": "#1e3a5f",
          "line-width": 6,
        },
      });

      // 경로 레이어 추가 (메인)
      this.map.addLayer({
        id: this.rtkRouteLayerId,
        type: "line",
        source: this.rtkRouteSourceId,
        layout: {
          "line-join": "round",
          "line-cap": "round",
        },
        paint: {
          "line-color": "#3b82f6",
          "line-width": 4,
        },
      });

      // 시작점 마커 (최신 위치 - 빨간색)
      const startEl = document.createElement("div");
      startEl.className = "route-start-marker";
      startEl.innerHTML = `
        <div style="
          background: #ef4444;
          border: 2px solid #fff;
          border-radius: 50%;
          width: 14px;
          height: 14px;
          box-shadow: 0 2px 6px rgba(0,0,0,0.3);
        "></div>
      `;
      const startMarker = new mapboxgl.Marker({ element: startEl })
        .setLngLat(coordinates[0])
        .addTo(this.map);

      // 끝점 마커 (과거 위치 - 초록색)
      const endEl = document.createElement("div");
      endEl.innerHTML = `
        <div style="
          background: #22c55e;
          border: 2px solid #fff;
          border-radius: 50%;
          width: 14px;
          height: 14px;
          box-shadow: 0 2px 6px rgba(0,0,0,0.3);
        "></div>
      `;
      const endMarker = new mapboxgl.Marker({ element: endEl })
        .setLngLat(coordinates[coordinates.length - 1])
        .addTo(this.map);

      // 재생용 마커 생성 (초기에는 숨김)
      const playbackEl = document.createElement("div");
      playbackEl.innerHTML = `
        <div style="
          background: #f59e0b;
          border: 3px solid #fff;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.4);
        "></div>
      `;
      this.routePlaybackMarker = new mapboxgl.Marker({ element: playbackEl })
        .setLngLat(coordinates[0])
        .addTo(this.map);
      playbackEl.style.display = "none";

      // 재생 마커에 Popup 추가
      const popup = new mapboxgl.Popup({
        offset: 25,
        closeButton: false,
        closeOnClick: false,
        className: "route-info-popup",
      });
      this.routePlaybackMarker.setPopup(popup);

      // 마커 저장 (제거용)
      this.rtkRouteMarkers = [startMarker, endMarker];

      // 경로에 맞게 지도 뷰 조정
      const bounds = coordinates.reduce(
        (bounds, coord) => bounds.extend(coord),
        new mapboxgl.LngLatBounds(coordinates[0], coordinates[0])
      );
      this.map.fitBounds(bounds, { padding: 80, maxZoom: 16 });
    },
    clearRtkRoute(restoreView = true) {
      if (!this.map) return; // Map doesn't exist yet

      // 재생 중지
      this.stopRoute();

      // 레이어 제거
      if (this.map.getLayer(this.rtkRouteLayerId)) {
        this.map.removeLayer(this.rtkRouteLayerId);
      }
      if (this.map.getLayer(this.rtkRouteLayerId + "-outline")) {
        this.map.removeLayer(this.rtkRouteLayerId + "-outline");
      }
      // 소스 제거
      if (this.map.getSource(this.rtkRouteSourceId)) {
        this.map.removeSource(this.rtkRouteSourceId);
      }
      // 마커 제거
      if (this.rtkRouteMarkers) {
        this.rtkRouteMarkers.forEach((marker) => marker.remove());
        this.rtkRouteMarkers = [];
      }
      // 재생 마커 제거
      if (this.routePlaybackMarker) {
        this.routePlaybackMarker.remove();
        this.routePlaybackMarker = null;
      }
      // 경로 좌표 초기화
      this.routeCoordinates = [];
      this.routeCurrentIndex = 0;

      // 원래 지도 위치로 복원
      if (restoreView && this.savedMapView) {
        this.map.flyTo({
          center: this.savedMapView.center,
          zoom: this.savedMapView.zoom,
          pitch: this.savedMapView.pitch,
          bearing: this.savedMapView.bearing,
          duration: 1000, // 1초 애니메이션
        });
        this.savedMapView = null;
      }
    },
    playRoute() {
      if (this.routeCoordinates.length < 2) return;
      if (this.routePlaying) return;

      this.routePlaying = true;

      // 재생 마커 표시 및 Popup 열기
      if (this.routePlaybackMarker) {
        this.routePlaybackMarker.getElement().style.display = "block";
        this.routePlaybackMarker.setLngLat(
          this.routeCoordinates[this.routeCurrentIndex]
        );
        // Popup 강제로 열기
        const popup = this.routePlaybackMarker.getPopup();
        if (popup && !popup.isOpen()) {
          this.routePlaybackMarker.togglePopup();
        }
      }

      this.updateRouteInfo();
      this.animateRoute();
    },
    animateRoute() {
      if (!this.routePlaying) return;
      if (this.routeCurrentIndex >= this.routeCoordinates.length - 1) {
        // 끝에 도달하면 재생 완료
        this.routePlaying = false;
        return;
      }

      this.routeCurrentIndex++;
      const coord = this.routeCoordinates[this.routeCurrentIndex];

      if (this.routePlaybackMarker) {
        this.routePlaybackMarker.setLngLat(coord);
      }

      // 정보 업데이트
      this.updateRouteInfo();

      this.routeAnimationId = setTimeout(() => {
        this.animateRoute();
      }, this.routePlaybackSpeed);
    },
    pauseRoute() {
      this.routePlaying = false;
      if (this.routeAnimationId) {
        clearTimeout(this.routeAnimationId);
        this.routeAnimationId = null;
      }
    },
    stopRoute() {
      this.pauseRoute();
      this.routeCurrentIndex = 0;

      // Popup 닫기
      if (this.routePlaybackMarker) {
        const popup = this.routePlaybackMarker.getPopup();
        if (popup && popup.isOpen()) {
          popup.remove();
        }
      }

      // 재생 마커 숨김 및 시작점으로 이동
      if (this.routePlaybackMarker && this.routeCoordinates.length > 0) {
        this.routePlaybackMarker.getElement().style.display = "none";
        this.routePlaybackMarker.setLngLat(this.routeCoordinates[0]);
      }
    },
    updateRouteInfo() {
      if (!this.routePlaybackMarker || !this.routeData[this.routeCurrentIndex])
        return;

      const point = this.routeData[this.routeCurrentIndex];
      const speed =
        point.speed !== null && point.speed !== undefined
          ? `${Number(point.speed).toFixed(1)} km/h`
          : "-";

      // deviceTime 필드 우선 사용
      const timestamp =
        point.deviceTime || point.createDatetime || point.timestamp;
      const timeStr = timestamp
        ? new Date(timestamp).toLocaleTimeString("ko-KR", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          })
        : "-";

      // Popup 내용 업데이트
      const popup = this.routePlaybackMarker.getPopup();
      if (popup) {
        // 스타일이 적용된 HTML 설정
        popup.setHTML(`
          <div style="
            background: #1a1f2e;
            color: #fff;
            padding: 5px 10px;
            border-radius: 4px;
            font-size: 12px;
            border: 1px solid #3b82f6;
            box-shadow: 0 2px 10px rgba(0,0,0,0.5);
          ">
            <div style="margin-bottom: 3px;">
              <span style="color: #8b95a8; font-size: 10px;">시간:</span>
              <span style="font-weight: 600; margin-left: 4px;">${timeStr}</span>
            </div>
            <div>
              <span style="color: #8b95a8; font-size: 10px;">속도:</span>
              <span style="font-weight: 600; color: #6ee7b7; margin-left: 4px;">${speed}</span>
            </div>
          </div>
        `);
      }
    },
    trackEquipment(deviceId) {
      this.trackingDeviceId = deviceId;
      // Initial center on device (will be handled by next updateRtkPositions call)
      console.log("Tracking equipment:", deviceId);
    },
    stopTracking() {
      this.trackingDeviceId = null;
      console.log("Stopped tracking");
    },
    haversineDistance(lat1, lon1, lat2, lon2) {
      const R = 6371; // 지구 반지름 (단위: km)
      const toRad = (degree) => (degree * Math.PI) / 180;

      const dLat = toRad(lat2 - lat1);
      const dLon = toRad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) *
          Math.cos(toRad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c; // 단위: km
    },
    calculateTotalDistance(coordinates) {
      let totalDistance = 0;

      for (let i = 0; i < coordinates.length - 1; i++) {
        const [lat1, lon1] = coordinates[i];
        const [lat2, lon2] = coordinates[i + 1];
        console.log(lat1);
        console.log(lon1);

        totalDistance += this.haversineDistance(lat1, lon1, lat2, lon2);
      }

      return totalDistance;
    },
    calculateTotalTime(time) {
      const totalTimeSecond = time.length;
      const hours = Math.floor(totalTimeSecond / 3600);
      const minutes = Math.floor((totalTimeSecond % 3600) / 60);
      const seconds = totalTimeSecond % 60;
      return hours + ":" + minutes + ":" + seconds;
    },
    openManual() {
      window.open("/manual/manual.html", "_blank");
    },
    onClickSetting() {
      this.menu = !this.menu;
      console.log("click");
      this.$refs.popupDashAdmin.toggle();
    },
    changeWeather() {
      this.$refs.confirmWeather.open();
    },
    weatherCallBack(param) {
      this.location = param.location;
    },
  },
  pad(number) {
    return number < 10 ? "0" + number : number;
  },
};
</script>
<style scoped>
::-webkit-scrollbar {
  display: none;
}
.header .header_inner p.menu_btn {
  position: relative;
  width: 80px;
  height: 60px;
  border-left: 1px solid #30363d;
  padding: 12px;
}
.header_view_btn {
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 10px;
}
.header_view_btn .btn_view {
  padding: 6px 12px;
  background: linear-gradient(135deg, #3a7bd5 0%, #00d2ff 100%);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  line-height: 1.2;
}
.header_view_btn .btn_view:hover {
  background: linear-gradient(135deg, #00d2ff 0%, #3a7bd5 100%);
  transform: scale(1.05);
}
.header_view_btn .btn_analysis {
  margin-left: 16px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
}
.header_view_btn .btn_analysis:hover {
  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%);
}
.header_view_btn .btn_manual {
  margin-left: 12px;
  background: linear-gradient(135deg, #10b981 0%, #22c55e 100%);
}
.header_view_btn .btn_manual:hover {
  background: linear-gradient(135deg, #22c55e 0%, #10b981 100%);
}
.header_view_btn .btn_admin {
  margin-left: 12px;
  background: linear-gradient(135deg, #f97316 0%, #fb923c 100%);
}
.header_view_btn .btn_admin:hover {
  background: linear-gradient(135deg, #fb923c 0%, #f97316 100%);
}
.canvas_wrap_fullscreen {
  position: fixed !important;
  top: 60px !important;
  left: 0 !important;
  width: 100% !important;
  height: calc(100vh - 60px) !important;
  z-index: 10;
}
.map_wrap_fullscreen {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
}
.route-info-popup .mapboxgl-popup-content {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
}
.route-info-popup .mapboxgl-popup-tip {
  border-top-color: #3b82f6 !important;
}
</style>
